export default __webpack_public_path__ + "static/media/whatsapp-block-alert.de86398e.png";